import { CModal } from "components/widget/CModal"
import { SvgCalender } from "icons/SvgCalender"
import { SvgCandle } from "icons/SvgCandle"
import { SvgChart } from "icons/SvgChart"
import { LayoutStore } from "store/layout-store"
import { ModalGraphSettingsProps } from "types/layout-types"
import { methodHandelChangeFields } from "utils/layout-utils"


export const ModalGraphSettings = ({ visible, setVisible }: ModalGraphSettingsProps) => {
    const { dashboardChartType, setDashboardChartType, dashboardChartPeriod, setDashboardChartPeriod } = LayoutStore()



    return (
        <>
            <CModal visible={visible} setVisible={setVisible} uId="ModalGraphSettings">
                <div className="w-full flex flex-col p-4 text-white">
                    <div className="w-full flex flex-col items-center">
                        <span>نوع چارت :</span>
                        <div className="full flex items-center mt-3">
                            <button onClick={()=>{setDashboardChartType('line')}} className={`w-[130px] py-3 border rounded  text-sm flex flex-col items-center justify-center  ${dashboardChartType == 'line' ? 'text-trade-75 border-trade-75 stroke-trade-75' : 'text-gray-400 border-gray-500 stroke-gray-400'} `}>
                                <SvgChart className="w-[30px] " />
                                <span className="mt-2"> خطی</span>
                            </button>
                            <button onClick={()=>{setDashboardChartType('candle')}} className={`w-[130px] py-3 border rounded mr-2 text-sm flex flex-col items-center justify-center  ${dashboardChartType == 'candle' ? 'text-trade-75 border-trade-75 stroke-trade-75' : 'text-gray-400 border-gray-400 stroke-gray-400'} `}>
                                <SvgCandle className="w-[30px] " />
                                <span className="mt-2">کندل</span>
                            </button>
                        </div>
                    </div>

                    <div className="w-full flex flex-col items-center mt-4">
                        <span> دوره نمایش :</span>
                        <div className="full flex items-center mt-3">
                            <button onClick={()=>{setDashboardChartPeriod('today_trades')}} className={`w-[130px] py-3 border rounded  text-sm flex flex-col items-center justify-center  ${dashboardChartPeriod == 'today_trades' ? 'text-trade-75 border-trade-75 fill-trade-75' : 'text-gray-400 border-gray-500 fill-gray-400'} `}>
                                <SvgCalender className="w-[30px] " />
                                <span className="mt-2"> تارگت روزانه</span>
                            </button>
                            <button onClick={()=>{setDashboardChartPeriod('all_days')}} className={`w-[130px] py-3 border rounded mr-2 text-sm flex flex-col items-center justify-center  ${dashboardChartPeriod == 'all_days' ? 'text-trade-75 border-trade-75 fill-trade-75' : 'text-gray-400 border-gray-400 fill-gray-400'} `}>
                                <SvgCalender className="w-[30px] " />
                                <span className="mt-2">کل تارگت</span>
                            </button>
                        </div>
                    </div>

                    <button onClick={()=>{setVisible(false)}} className="w-full h-[40px] mt-6 rounded-md border border-trade-75 text-trade-75 text-sm ">بستن</button>
                </div>
            </CModal>
        </>
    )
}